<template>
  <van-sticky>
    <div class="hScaffoldParentDiv">
      <van-nav-bar v-if="!hideNav"
                   :border="false"
                   :style="{
              backgroundColor: bg ? bg : HNewGameUIConfig.newGameUIType === 1
                ?'#FFE88A'
                : HNewGameUIConfig.newGameUIType === 2
                    ? '#FF7373'
                    : HNewGameUIConfig.newGameUIType === 3
                        ? '#111111'
                        : 'white'
                  }"
                   safe-area-inset-top
                   @clickLeft="onClickLeft"
                   @clickRight="rightCallback"
      >
        <template #title>
          <div :style="hcf.getTextStyle({
            addSize:3,color:HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'
          })">{{ title }}</div>
        </template>
        <template v-if="!hideLeftBackBtn" #left>
          <van-icon name="arrow-left" size="21" :color="HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'"/>
        </template>
        <template v-if="rightText!==''" #right>
          <div :style="hcf.getTextStyle({
          addSize:1,color:HNewGameUIConfig.newGameUIType ===1?'#111':HNewGameUIConfig.newGameUIType ===2? 'white':'main'
         })">{{ rightText }}</div>
        </template>
        <template v-if="rightText===''" #right>
          <slot name="customRight"/>
        </template>
      </van-nav-bar>
      <slot name="header"/>
    </div>
  </van-sticky>
  <div class="contentStyle">
    <slot/>
  </div>
</template>


<script setup>
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hr} from "@/components/utils/HRouter.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  defineProps(
      {
        title: {
          type: String,
          default: ''

        },
        rightText: {
          type: String,
          default: ''
        },
        customRight: {
          default: false,
        },
        hideNav: {
          default: false
        },
        rightCallback: Function,
        hideLeftBackBtn: {
          default: false,
        },
        bg: {
          type: String,
          default: ''
        }
      });

  function onClickLeft() {
    hr.goBack();
  }
</script>


<style scoped>
  .contentStyle {
    width: 100%;
    /*tabbar 高度*/
    height: calc(100% - 46px);
    /* body 已锁 viewport, 各页内容改为容器内部滚动 */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  .hScaffoldParentDiv {
    display: flex;
    flex-direction: column;
  }
</style>
